import Auth from "@aws-amplify/auth"
import * as AWS from 'aws-sdk/global'
import cfg from '@/services/aws/amplify/cfg'
import StoreConstants from "@/store/StoreConstants";
import store from "@/store"

Auth.configure(cfg)

class AuthService {
  constructor() {
    this.idToken = null
    this.expiresAt = null
    this.accessKey = null
    this.secretKey = null
    this.sessionToken = null

    this.authCheckPromise = this.checkAuth()
  }

  async checkAuth() {
    try {
      const currentUser = await Auth.currentAuthenticatedUser()

      if(!currentUser || !currentUser.signInUserSession) {
        console.log(JSON.stringify(currentUser, null, 2))
        throw new Error('not authenticated')
      }
      const session = currentUser.signInUserSession
      if(session && session.idToken && session.idToken.payload && !session.idToken.payload.email_verified) {
        throw new Error('email is not yet verified')
      }
      await this.init(session)
      console.log('logged in')
    } catch(e) {
      console.log(e)
    }
  }

  authCheck() {
    console.log('auth check')
    return this.authCheckPromise
  }

  async login() {
    await Auth.federatedSignIn()
  }
  isLoggedIn() {
    return !!this.idToken
  }
  async logout() {
    if(AWS.config.credentials) {
      AWS.config.credentials.clearCachedId()
      AWS.config.credentials = null
    }

    await Auth.signOut({
      global: false
    })

    this.accessKey = null
    this.secretKey = null
    this.sessionToken = null
    this.idToken = null
    this.expiresAt = null

    await store.commit(StoreConstants.commits.setCredentials, null)
  }

  async init(session) {
    console.log('AuthService.init')
    let domain = session.idToken.payload.iss
    if(domain.startsWith('https://')) {
      domain = domain.replace('https://', '')
    }


    this.idToken = session.idToken.jwtToken
    this.expiresAt = session.idToken.payload.exp * 1000

    AWS.config.correctClockSkew = true
    AWS.config.region = 'us-west-2'
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      region: 'us-west-2',
      IdentityPoolId: cfg.aws_cognito_identity_pool_id,
      RoleArn: cfg.aws_role_arn,
      Logins: {
        [domain]: this.idToken
      },
    })

    let error
    await AWS.config.credentials.getPromise().catch((err) => {
      error = err
      // eslint-disable-next-line no-console
      console.log(error)
    })
    if(error) throw error

    this.accessKey = AWS.config.credentials.accessKeyId
    this.secretKey = AWS.config.credentials.secretAccessKey
    this.sessionToken = AWS.config.credentials.sessionToken

    await store.commit(StoreConstants.commits.setCredentials, {
      idToken: this.idToken,
      accessKey: this.accessKey,
      secretKey: this.secretKey,
      sessionToken: this.sessionToken,
      region: 'us-west-2',
      defaultContentType: 'application/json',
      defaultAcceptType: 'application/json'
    })
    await store.dispatch(StoreConstants.actions.loadAccount)
  }
}

// Hub.listen('auth', (data) => {
//   switch(data.payload.event) {
//     case 'signIn':{
//       console.info('user signed in')
//       const redirect = localStorage.getItem('redirect')
//       if (redirect) {
//         alert('going to ' + redirect)
//         window.location = redirect
//       }
//       break
//     }
//     case 'signUp': {
//       console.info('user signed up')
//       const redirect = localStorage.getItem('redirect')
//       if (redirect) {
//         alert('going to ' + redirect)
//         window.location = redirect
//       }
//       break
//     }
//     case 'signOut':
//       console.info('user signed out')
//       break
//     case 'signIn_failure':
//       console.error('user sign in failed')
//       break
//     case 'tokenRefresh':
//       console.info('token refresh succeeded')
//       break
//     case 'tokenRefresh_failure':
//       console.error('token refresh failed')
//       break
//     case 'configured':
//       console.info('the Auth module is configured')
//   }
// })

export default (new AuthService())